var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Meta'),_vm._v(" "),(!/:\/\/framagenda.org\/apps\/registration/.test(_vm.$t('url')))?_c('sidebar-menu'):_vm._e(),_vm._v(" "),_c('alert'),_vm._v(" "),_c('modal-info'),_vm._v(" "),(/:\/\/framateam.org/.test(_vm.$t('url')))?_c('framateam'):_vm._e(),_vm._v(" "),_c('footer-menu'),_vm._v(" "),_c('back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }